import { render, staticRenderFns } from "./paper_detail.vue?vue&type=template&id=247b324e&scoped=true"
import script from "./paper_detail.vue?vue&type=script&lang=js"
export * from "./paper_detail.vue?vue&type=script&lang=js"
import style0 from "./paper_detail.vue?vue&type=style&index=0&id=247b324e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247b324e",
  null
  
)

export default component.exports